//chapter1
export default {
    id : 13,//chapter number
    title : '13. 패키지 쏘잉 & 쏘팅 공정(Sawing & Sorting) (3)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/13/videos/a13.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '쏘잉 & 쏘팅 공정',
            ],
            body2 : [
                '쏘잉 & 쏘팅 공정에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/13/videos/13.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '쏘팅이 완료된 패키지는 육안검사 과정을 거친 후 트레이에 담겨지게 된다.',//html available
                    answer : "2",
                    explain : '비전 검사를 통해서 쏘팅이 완료된 패키지는 쏘터 내에서 분류가 되어 트레이에 담겨지게 된다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '패키지 쏘잉 공정 중에는 솔더 볼 관련 불량 현상이 발생할 가능성은 없다.',//html available
                    answer : "2",
                    explain : '패키지 쏘잉 공정 중에 솔더 볼이 떨어져나가는 불량 현상 등이 발생할 수 있으므로 주의할 필요가 있다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>쏘잉 & 쏘팅 공정<br>
                        - 패키지 쏘잉<br>
                        - 드라이 유닛은 가열된 plate에 패키지를 올려 놓고 일반 에어를 분사하여 수분을 증발시킴<br>
                        - 드라이 유닛은 유닛 Picker에 의해 패키지를 공급 받고 다시 턴테이블 Picker에 의해 턴테이블로 이송됨<br>
                        - 쏘잉이 완료된 Package는 턴테이블 Picker에 의해 드라이 유닛에서 턴테이블 유닛으로 옮겨짐<br>
                        - 드라이 유닛을 통해 수분이 완전히 제거된 패키지들이 턴테이블 Picker에 의해 턴테이블 위에 올려지면 턴테이블은 두 번째 비전 구역으로 이동하여 비전 검사를 진행함<br>
                        - 양품과 불량품으로 나뉜 패키지들이 방향성에 맞게 트레이에 놓을 수 있도록  0~300° 회전할 수 있는 기능이 있음<br>
                        - 비전 검사를 통해  Ball 불량, 패키지 크기 불량, Marking 검사를 통해 불량 제품 검출 기능을 가지고 있음</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/13/videos/a13.mp4',
        },
    ]
}